// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MhWi","colBig":"styles_colBig__RKUpP","colSmall":"styles_colSmall__uvdwz"};